import { defineStore } from 'pinia';

interface MaskState {
  visible: boolean;
}

const useMaskStore = defineStore('mask', {
  state: (): MaskState => ({
    visible: false,
  }),
  actions: {
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    toggle() {
      this.visible = !this.visible;
    },
  },
});

export default useMaskStore;
